import { BlockType } from '../../../models/enums';
import { events } from '../../../common/constant';
import { getNormalizedKey } from '../../../common/utils/common';
/**
 * `SlashCommandModule` module is used to handle the slash command actions in the BlockEditor.
 *
 * @hidden
 */
export class SlashCommandModule {
    constructor(manager) {
        this.isPopupOpened = false;
        this.shortcutMap = new Map();
        this.parent = manager;
        this.addEventListeners();
    }
    addEventListeners() {
        this.parent.observer.on(events.keydown, this.onKeyDown, this);
        this.parent.observer.on('slashMenuCreated', this.handleSlashMenuCreated, this);
        this.parent.observer.on('slashCommandChange', this.handleSlashCommandChange, this);
        this.parent.observer.on('updateSlashMenuPopupState', this.updateSlashMenuPopupState, this);
        this.parent.observer.on(events.destroy, this.destroy, this);
    }
    removeEventListeners() {
        this.parent.observer.off(events.keydown, this.onKeyDown);
        this.parent.observer.off('slashMenuCreated', this.handleSlashMenuCreated);
        this.parent.observer.off('slashCommandChange', this.handleSlashCommandChange);
        this.parent.observer.off('updateSlashMenuPopupState', this.updateSlashMenuPopupState);
        this.parent.observer.off(events.destroy, this.destroy);
    }
    handleSlashMenuCreated() {
        this.buildShortcutMap();
    }
    buildShortcutMap() {
        this.shortcutMap.clear();
        this.parent.commandMenuSettings.commands.forEach((item) => {
            this.shortcutMap.set(item.shortcut.toLowerCase(), item);
        });
    }
    onKeyDown(e) {
        const normalizedKey = getNormalizedKey(e);
        if (!normalizedKey) {
            return;
        }
        const commandItem = this.shortcutMap.get(normalizedKey);
        if (commandItem) {
            e.preventDefault();
            this.transformBlocks(commandItem);
        }
    }
    handleSlashCommandChange(args) {
        this.transformBlocks(args.itemData);
    }
    getHeadingProps(itemId) {
        const extractedType = itemId.replace('-command', '');
        const level = parseInt(extractedType.slice(-1), 10);
        return { level };
    }
    transformBlocks(commandItem) {
        const selectedItem = commandItem.type;
        if (!selectedItem || !this.parent.currentFocusedBlock) {
            return;
        }
        const isHeadingType = selectedItem === BlockType.Heading || selectedItem === BlockType.CollapsibleHeading;
        const headingProps = isHeadingType ? this.getHeadingProps(commandItem.id) : undefined;
        this.parent.blockCommand.transformBlocksForSelection(selectedItem, headingProps);
    }
    updateSlashMenuPopupState(options) {
        this.isPopupOpened = options.isOpen;
        if (!options.isOpen) {
            this.parent.isPopupOpenedOnAddIconClick = false;
        }
    }
    /**
     * Checks whether the slash command popup is opened or not.
     *
     * @returns {boolean} - Returns true if the slash command popup is opened, otherwise false.
     * @hidden
     */
    isPopupOpen() {
        const mentionPopupId = `${this.parent.blockContainer.id}_popup`;
        const commandPopupElement = document.querySelector(`#${mentionPopupId}.e-blockeditor-command-menu`);
        return this.isPopupOpened && (commandPopupElement && commandPopupElement.classList.contains('e-popup-open'));
    }
    /**
     * Hides the slash command popup.
     *
     * @returns {void}
     * @hidden
     */
    hidePopup() {
        this.parent.observer.notify('hideSlashMenuPopup');
    }
    /**
     * Shows the slash command popup.
     *
     * @returns {void}
     * @hidden
     */
    showPopup() {
        this.parent.observer.notify('showSlashMenuPopup');
    }
    filterCommands(text, xOffset, yOffset) {
        this.parent.observer.notify('filterSlashCommands', { text, offsetX: xOffset, offsetY: yOffset });
    }
    /**
     * Destroys the slash command module.
     *
     * @returns {void}
     */
    destroy() {
        this.removeEventListeners();
        this.shortcutMap = null;
    }
}
